<template>
	<v-card flat>
		<div class="basket-product-height delivery">
			<div class="width-product-description">
				<div class="product-title-price-wrapper">
					<div class="product-title">{{tagToTranslationKey(extractlabelFromTag)}}</div>
					<div class="product-price">{{formatPriceZero(receiptLine.totalPrice)}}</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import {formatPriceZero} from "../../../../domains2/libraries/Utils";
export default {
	name: "OrderDelivery",
	props: ["receiptLine"],
	computed: {
		extractlabelFromTag(){
			const self = this;
			return self.receiptLine.tags.length > 0 && self.receiptLine.tags[0];
		}
	},
	methods: {
		formatPriceZero,
		tagToTranslationKey(tag){
			if(tag === "Delivery") {
				return this.$t("common.deliveryMethods.DELIVERY");
			}
		}
	}
};
</script>

<style scoped lang="scss">
.basket-product-height.delivery {
	min-height: 41px;
	.product-title-price-wrapper {
		margin-bottom: 0;
	}
}
</style>
